import React from 'react';

import { Container, Wave, LoadingText } from './LoadingIcon.styled';

const LoadingIcon: React.FC = () => {
    return (
        <Container>
            <Wave />
            <LoadingText>Loading...</LoadingText>
        </Container>
    );
};

export default LoadingIcon;
